import { useMemo } from 'react';
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';

export interface HealthResult {
    healthStatus: string;
    descTest: string;
    icon: string;
    iconFill: string;
    color: 'very-low' | 'low' | 'medium' | 'high' | 'very-high';
}

const levelMap: Record<string, HealthResult> = {
    very_low: {
        healthStatus: 'Очень низкий',
        descTest: 'Состояние требует немедленного внимания. Начните улучшать здоровье прямо сейчас.',
        icon: 'health-emotion-very-low',
        iconFill: '#99309b',
        color: 'very-low',
    },
    below_normal: {
        healthStatus: 'Ниже нормы',
        descTest: 'Уровень здоровья ниже среднего. Есть над чем поработать.',
        icon: 'health-emotion-low',
        iconFill: '#B76CB7',
        color: 'low',
    },
    normal: {
        healthStatus: 'Нормальный',
        descTest: 'Вы в пределах нормы, но стоит обратить внимание на питание.',
        icon: 'health-emotion-medium',
        iconFill: '#DDDDDD',
        color: 'medium',
    },
    above_average: {
        healthStatus: 'Выше среднего',
        descTest: 'Вы в хорошем состоянии, продолжайте в том же духе.',
        icon: 'health-emotion-high',
        iconFill: '#23857CB2',
        color: 'high',
    },
    high: {
        healthStatus: 'Высокий',
        descTest: 'Вы в отличной форме! Так держать!',
        icon: 'health-emotion-very-high',
        iconFill: '#23857C',
        color: 'very-high',
    },
};

export const useHealthResults = () => {
    const overallLevel = useAppSelector((state) => state.questionnaire.riskResult?.overall_level);
    const overallExplanation = useAppSelector((state) => state.questionnaire.riskResult?.overall_explanation);

    const mapped = useMemo<HealthResult | null>(() => {
        if (!overallLevel) return null;
        const base = levelMap[overallLevel];
        if (!base) return null;
        return {
            ...base,
            descTest: overallExplanation || base.descTest,
        };
    }, [overallLevel, overallExplanation]);

    return mapped;
};
